export const getLocalAgreement = (authUser: string | null): string | null => {
  try {
    const lsAgreement = localStorage.getItem(`agreement-${authUser}`)
    if (lsAgreement) {
      const { user, step } = JSON.parse(lsAgreement)
      return user === authUser ? step : '1'
    } else {
      return null
    }
  } catch {
    return null
  }
}
